import LockOutlined from '@mui/icons-material/LockOutlined';
import { Box, Link, Tooltip } from '@/shared/ui';

const RestrictedIconWithTooltip = () => (
  <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end' }}>
    <Tooltip
      variant='plain'
      title={
        <>
          You don't have access to this.{' '}
          <Link
            color='gx.text'
            href='https://www.general-index.com/contact-us'
            rel='noopener noreferrer'
            sx={{ fontWeight: 700 }}
            target='_blank'
          >
            Request access
          </Link>
        </>
      }
    >
      <LockOutlined sx={{ fontSize: '15px', color: '#cccccc' }} />
    </Tooltip>
  </Box>
);
export default RestrictedIconWithTooltip;
